import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import {
  generateQuestionStruct,
  generateQuestionStructNew,
  moduleSubTopic,
  quesDistributionPattern,
  questionDistributionPatternContent,
  questionDistributionPatternTableHeaders,
  questionDistributionSubTopicInfo,
  questionSpecification,
  readOnlyQuestionsData,
  subTopicQuestionDetail,
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';

@Component({
  selector: 'app-question-distribution-pattern',
  templateUrl: './question-distribution-pattern.component.html',
  styleUrls: ['./question-distribution-pattern.component.scss'],
})
export class QuestionDistributionPatternComponent implements OnInit {
  readOnlyHeaderData: readOnlyQuestionsData[] = [
    { questionType: 'MCQ Questions', numberOfQuestions: 0 },
    { questionType: 'Freetext Questions', numberOfQuestions: 0 },
    { questionType: 'Total Questions', numberOfQuestions: 0 },
  ];

  // tableHeaders: questionDistributionPatternTableHeaders[] = [
  //   { title: 'Sub Topics', subTitles: [] },
  //   { title: 'Total ', subTitles: ['MCQ+Freetext'] },
  //   { title: 'MCQ', subTitles: ['Easy', 'Medium', 'Hard', 'Total MCQ'] },
  //   {
  //     title: 'Freetext',
  //     subTitles: ['Easy', 'Medium', 'Hard', 'Total Freetext'],
  //   },
  // ];

  notifier: NotifierService;

  tableHeadersInfo = {
    titlesInfo: [
      {
        title: 'Sub Topics',
        extraText: '',
        spanInfo: { rowValue: 2, colValue: '' },
      },
      {
        title: 'Total',
        extraText: 'MCQ+Freetext',
        spanInfo: { rowValue: 2, colValue: '' },
      },
      {
        title: 'MCQ',
        extraText: '',
        spanInfo: { rowValue: '', colValue: 4 },
      },
      {
        title: 'Freetext',
        extraText: '',
        spanInfo: { rowValue: '', colValue: 4 },
      },
    ],
    subTitlesInfo: {
      mcqSubtitles: {
        subtitles: ['Easy', 'Medium', 'Hard', 'Total MCQ'],
        linkedTo: 'MCQ',
      },

      freetextSubtitles: {
        subtitles: ['Easy', 'Medium', 'Hard', 'Total Freetext'],
        linkedTo: 'Freetext',
      },
    },
  };

  tableContent: questionDistributionPatternContent = {
    moduleName: '',
    moduleId: 0,
    subTopicInfo: [],
    totalQuestions: 0,
    totalMcqQuestions: 0,
    totalFreetextQuestions: 0,
    canRepeatQuestions: false,
    onlyExerciseQuestions: false,
    onlyQuizQuestions: false,
  };

  subTopicInfoForm: FormGroup = new FormGroup({
    // mcqEasy: new FormControl(''),
    // mcqMedium: new FormControl(''),
    // mcqHard: new FormControl(''),
    // mcqTotal: new FormControl(''),
    // freetextEasy: new FormControl(''),
    // freetextMedium: new FormControl(''),
    // freetextHard: new FormControl(''),
    // freetextTotal: new FormControl(''),
  });

  generateQuestionStructArr: generateQuestionStruct[] = [];

  quesFinalPattern: quesDistributionPattern = {
    isValidQuestionnaire: false,
    questionStructList: [],
  };

  difficultyLevels = [
    {
      level: 1,
      name: 'easy',
    },
    {
      level: 2,
      name: 'medium',
    },
    {
      level: 3,
      name: 'hard',
    },
  ];

  isGenerateQuestionsAllowed: boolean = false;

  areQuestionsGenerating: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public questionData: moduleSubTopic,
    private dialogRef: MatDialogRef<QuestionDistributionPatternComponent>,
    private globalApiService: GlobalApiService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    console.log(this.questionData);
    this.makeTableContentSructure();
    // this.createQuestionAPI();
  }

  makeFormControls() {
    let controls: any = {};
    for (let i = 0; i < this.tableContent.subTopicInfo.length; i++) {
      let subTopicId = this.tableContent.subTopicInfo[i].subTopicId;
      controls[`mcq-easy-${subTopicId}`] = new FormControl('', [
        Validators.pattern('^[0-9]*$'),
      ]);
      controls[`mcq-medium-${subTopicId}`] = new FormControl('', [
        Validators.pattern('^[0-9]*$'),
      ]);
      controls[`mcq-hard-${subTopicId}`] = new FormControl('', [
        Validators.pattern('^[0-9]*$'),
      ]);
      controls[`mcq-total-${subTopicId}`] = new FormControl(0);
      controls[`freetext-easy-${subTopicId}`] = new FormControl('', [
        Validators.pattern('^[0-9]*$'),
      ]);
      controls[`freetext-medium-${subTopicId}`] = new FormControl('', [
        Validators.pattern('^[0-9]*$'),
      ]);
      controls[`freetext-hard-${subTopicId}`] = new FormControl('', [
        Validators.pattern('^[0-9]*$'),
      ]);
      controls[`freetext-total-${subTopicId}`] = new FormControl(0);
    }
    console.log(controls);
    return controls;
  }

  makeTableContentSructure() {
    this.tableContent.moduleName = this.questionData.moduleName;
    this.tableContent.moduleId = this.questionData.moduleId;
    this.tableContent.canRepeatQuestions = this.questionData.canRepeatQuestions;
    // this.tableContent.onlyTestQuestions = this.questionData.onlyTestQuestions;
    this.tableContent.onlyQuizQuestions = this.questionData.onlyQuizQuestions;
    this.tableContent.onlyExerciseQuestions =
      this.questionData.onlyExerciseQuestions;
    this.questionData.moduleSubTopics.forEach(
      (moduleSubTopic, moduleSubTopicIndex) => {
        const subTopicInfo: questionDistributionSubTopicInfo = {
          subTopicId: moduleSubTopic.subTopicId,
          subTopicName: moduleSubTopic.subTopicName,
          totalMcqFreetext: 0,
          mcqs: {
            easy: 0,
            medium: 0,
            hard: 0,
            total: 0,
          },
          freetext: {
            easy: 0,
            medium: 0,
            hard: 0,
            total: 0,
          },
        };
        this.tableContent.subTopicInfo.push(subTopicInfo);
      }
    );
    this.subTopicInfoForm = new FormGroup(this.makeFormControls());
    console.log(this.subTopicInfoForm);
    // this.makeFormControls();
    this.fillUpExisitingData();
  }

  patchValueAndAddDeleteError(questionType: number) {}

  fillUpExisitingData() {
    if (this.questionData.existingQuestionDistributionPatterns!.length > 0) {
      this.questionData.existingQuestionDistributionPatterns?.forEach(
        (existingPattern) => {
          console.log(existingPattern, this.questionData);
          this.questionData.moduleSubTopics.forEach((moduleSubTopic) => {
            if (moduleSubTopic.subTopicId === existingPattern.subTopicId) {
              existingPattern.questionSpecifications.forEach((questionSpec) => {
                console.log(questionSpec);
                this.difficultyLevels.forEach((difficultyLevel) => {
                  let control = '';
                  if (difficultyLevel.level === questionSpec.difficultLevel) {
                    control =
                      questionSpec.questionType === 1
                        ? `mcq-${difficultyLevel.name}-${moduleSubTopic.subTopicId}`
                        : `freetext-${difficultyLevel.name}-${moduleSubTopic.subTopicId}`;
                    console.log('if- ', control);
                    this.subTopicInfoForm.controls[control].patchValue(
                      questionSpec.noOfQuestions
                    );
                    if (
                      questionSpec.noOfQuestions !==
                        questionSpec.presentQuestions &&
                      questionSpec.deletedQuestions! > 0
                    ) {
                      console.log('setting delete error');
                      setTimeout(() => {
                        this.subTopicInfoForm.controls[control].setErrors({
                          perfectGeneration: false,
                          questionsDeleted: true,
                          deletedQuestions: questionSpec.deletedQuestions,
                          presentQuestions: questionSpec.presentQuestions,
                          noOfQuestions: questionSpec.noOfQuestions,
                          generatedQuestions: questionSpec.questions?.length,
                        });
                      }, 1);
                      this.subTopicInfoForm.controls[
                        control
                      ].updateValueAndValidity();
                      console.log(this.subTopicInfoForm);
                    } else if (
                      questionSpec.noOfQuestions !==
                        questionSpec.presentQuestions &&
                      questionSpec.deletedQuestions! === 0
                    ) {
                      console.log('setting less generation error');
                      setTimeout(() => {
                        this.subTopicInfoForm.controls[control].setErrors({
                          perfectGeneration: false,
                          questionsDeleted: false,
                          deletedQuestions: questionSpec.deletedQuestions,
                          presentQuestions: questionSpec.presentQuestions,
                          noOfQuestions: questionSpec.noOfQuestions,
                          generatedQuestions: questionSpec.questions?.length,
                        });
                      }, 1);
                      this.subTopicInfoForm.controls[
                        control
                      ].updateValueAndValidity();
                      console.log(this.subTopicInfoForm);
                    }
                  }
                });
              });
              let totalMcqControl = `mcq-total-${moduleSubTopic.subTopicId}`;
              let totalFreetextControl = `freetext-total-${moduleSubTopic.subTopicId}`;
              let totalMcqPerSubTopic = 0;
              let totalFreetextPerSubTopic = 0;
              this.difficultyLevels.forEach(
                (difficultyLevel, difficultyLevelIndex) => {
                  let currentControlValue: number = 0;
                  let mcqDiffcultyControl = `mcq-${difficultyLevel.name}-${moduleSubTopic.subTopicId}`;
                  currentControlValue = parseInt(
                    this.subTopicInfoForm.controls[mcqDiffcultyControl].value
                  );
                  currentControlValue = isNaN(currentControlValue)
                    ? 0
                    : currentControlValue;
                  console.log(
                    typeof this.subTopicInfoForm.controls[mcqDiffcultyControl]
                      .value
                  );
                  totalMcqPerSubTopic =
                    totalMcqPerSubTopic + currentControlValue;
                  let freetextDiffcultyControl = `freetext-${difficultyLevel.name}-${moduleSubTopic.subTopicId}`;
                  currentControlValue = parseInt(
                    this.subTopicInfoForm.controls[freetextDiffcultyControl]
                      .value
                  );
                  currentControlValue = isNaN(currentControlValue)
                    ? 0
                    : currentControlValue;
                  totalFreetextPerSubTopic =
                    totalFreetextPerSubTopic + currentControlValue;
                }
              );
              this.subTopicInfoForm.controls[totalMcqControl].patchValue(
                totalMcqPerSubTopic
              );
              this.subTopicInfoForm.controls[totalFreetextControl].patchValue(
                totalFreetextPerSubTopic
              );
              let totalMcqOrFreetext = this.tableContent.subTopicInfo.find(
                (subTopic) => subTopic.subTopicId === moduleSubTopic.subTopicId
              );
              if (totalMcqOrFreetext) {
                let totalMcqPerSubTopicStr = totalMcqPerSubTopic.toString();
                let totalFreetextPerSubTopicStr =
                  totalFreetextPerSubTopic.toString();
                (
                  totalMcqOrFreetext as questionDistributionSubTopicInfo
                ).totalMcqFreetext =
                  parseInt(totalMcqPerSubTopicStr) +
                  parseInt(totalFreetextPerSubTopicStr);
              }
              console.log(
                totalMcqOrFreetext?.totalMcqFreetext,
                typeof totalMcqPerSubTopic,
                typeof totalFreetextPerSubTopic
              );
            }
          });
        }
      );
    }
    console.log(this.tableContent);
    this.makeTotalQuestionsPerModule();
    // if (
    //   this.questionData.existingQuestionDistributionPatterns!.length > 0 &&
    //   this.subTopicInfoForm.valid
    // ) {
    //   this.checkValidityAndCloseDialog(false);
    // }
    // this.tableContent.subTopicInfo[0].
    console.log(this.subTopicInfoForm);
  }

  getControl(index: number, isMcq: boolean, status: number): AbstractControl {
    let subTopicId = this.tableContent.subTopicInfo[index].subTopicId;
    const form = this.subTopicInfoForm;
    let controlKey = isMcq ? 'mcq-' : 'freetext-';
    controlKey =
      status === 1
        ? controlKey + 'easy'
        : status === 2
        ? controlKey + 'medium'
        : status === 3
        ? controlKey + 'hard'
        : status === 4
        ? controlKey + 'total'
        : '';
    // console.log(`${controlKey}-${subTopicId}`);
    let control = form.controls[`${controlKey}-${subTopicId}`];
    return control;
  }

  getControlValue(
    index: number,
    isMcq: boolean,
    status: number
  ): string | number {
    let subTopicId = this.tableContent.subTopicInfo[index].subTopicId;
    const form = this.subTopicInfoForm;
    let controlKey = isMcq ? 'mcq-' : 'freetext-';
    controlKey =
      status === 1
        ? controlKey + 'easy'
        : status === 2
        ? controlKey + 'medium'
        : status === 3
        ? controlKey + 'hard'
        : status === 4
        ? controlKey + 'total'
        : '';
    console.log(`${controlKey}-${subTopicId}`);
    let control = form.controls[`${controlKey}-${subTopicId}`];
    console.log(control);
    let controlValue: number = 0;
    if (control.value !== '') {
      controlValue = control.value;
    } else {
      controlValue = 0;
    }
    return controlValue;
  }

  setControlValue(
    index: number,
    isMcq: boolean,
    status: number,
    value: string | number
  ) {
    let subTopicId = this.tableContent.subTopicInfo[index].subTopicId;
    const form = this.subTopicInfoForm;
    let controlKey = isMcq ? 'mcq-' : 'freetext-';
    controlKey =
      status === 1
        ? controlKey + 'easy'
        : status === 2
        ? controlKey + 'medium'
        : status === 3
        ? controlKey + 'hard'
        : status === 4
        ? controlKey + 'total'
        : '';
    let control = form.controls[`${controlKey}-${subTopicId}`];
    control.patchValue(value);
    // let controlValue: string | number = control.value;
  }

  printProps(index: number, isMcq: boolean, status: number) {
    console.log(this.tableContent.subTopicInfo[index]);
    console.log(this.subTopicInfoForm);
    // let value = this.getControlValue(index)
    console.log(this.subTopicInfoForm.valid);
    if (this.subTopicInfoForm.valid) {
      this.makeTotalMcqsOrFreetextQuestionsPerSubTopic(index, isMcq);
    } else {
      let control = this.getControl(index, isMcq, status);
      console.log(control.errors);
      if (control.errors! === null || control.errors! === undefined) {
        this.makeTotalMcqsOrFreetextQuestionsPerSubTopic(index, isMcq);
      }
    }
    this.isGenerateQuestionsAllowed = false;
  }

  makeTotalMcqsOrFreetextQuestionsPerSubTopic(index: number, isMcq: boolean) {
    let subTopicId = this.tableContent.subTopicInfo[index].subTopicId;
    let totalControlKey = isMcq
      ? `mcq-total-${subTopicId}`
      : `freetext-total-${subTopicId}`;
    let totalMcqOrFreetextQuestions: number = 0;
    for (let statusIndex = 1; statusIndex < 4; statusIndex++) {
      let controlValue = this.getControlValue(index, isMcq, statusIndex);
      controlValue = parseInt(controlValue as string);
      totalMcqOrFreetextQuestions = totalMcqOrFreetextQuestions + controlValue;

      console.log(totalMcqOrFreetextQuestions);
    }
    console.log(totalMcqOrFreetextQuestions);
    this.setControlValue(index, isMcq, 4, totalMcqOrFreetextQuestions);
    this.makeTotalQuestionsPerSubTopic(index);
  }

  makeTotalQuestionsPerSubTopic(index: number) {
    let subTopic = this.tableContent.subTopicInfo[index];
    let totalMcqValue = this.getControlValue(index, true, 4);
    totalMcqValue = parseInt(totalMcqValue as string);
    let totalFreetextValue = this.getControlValue(index, false, 4);
    totalFreetextValue = parseInt(totalFreetextValue as string);
    subTopic.totalMcqFreetext = totalMcqValue + totalFreetextValue;
    console.log(subTopic.totalMcqFreetext);
    this.makeTotalQuestionsPerModule();
  }

  makeTotalQuestionsPerModule() {
    let totalMcqQuestionsPerModule: string | number = 0;
    let totalFreetextQuestionsPerModule: string | number = 0;
    let totalquestionPerModule: string | number = 0;
    for (
      let subTopicIndex = 0;
      subTopicIndex < this.tableContent.subTopicInfo.length;
      subTopicIndex++
    ) {
      let mcqValue = this.getControlValue(subTopicIndex, true, 4);
      mcqValue = parseInt(mcqValue as string);
      totalMcqQuestionsPerModule = totalMcqQuestionsPerModule + mcqValue;
      let freetextValue = this.getControlValue(subTopicIndex, false, 4);
      freetextValue = parseInt(freetextValue as string);
      totalFreetextQuestionsPerModule =
        totalFreetextQuestionsPerModule + freetextValue;
    }
    this.readOnlyHeaderData[0].numberOfQuestions = totalMcqQuestionsPerModule;
    this.readOnlyHeaderData[1].numberOfQuestions =
      totalFreetextQuestionsPerModule;
    totalquestionPerModule =
      totalMcqQuestionsPerModule + totalFreetextQuestionsPerModule;
    this.readOnlyHeaderData[2].numberOfQuestions = totalquestionPerModule;
  }

  changeIgnoredQuestionCategories(
    onlyExerciseQuestions: boolean,
    onlyQuizQuestions: boolean,
    generateQuestionsObj: generateQuestionStruct
  ) {
    generateQuestionsObj.ignoredQuestionCategories = [
      'EXCERSIZE_QUESTION',
      'QUIZ_QUESTION',
    ];
    if (onlyExerciseQuestions) {
      generateQuestionsObj.ignoredQuestionCategories =
        generateQuestionsObj.ignoredQuestionCategories.filter(
          (quesCat) => quesCat !== 'EXCERSIZE_QUESTION'
        );
    }
    if (onlyQuizQuestions) {
      generateQuestionsObj.ignoredQuestionCategories =
        generateQuestionsObj.ignoredQuestionCategories.filter(
          (quesCat) => quesCat !== 'QUIZ_QUESTION'
        );
    }
  }

  makeGenerateQuestionStruct(): void {
    let generateQuestionsObj: generateQuestionStruct = {
      moduleName: this.tableContent.moduleName,
      moduleId: this.tableContent.moduleId,
      subTopicQuestionDetails: [],
      generatedQuestions: [],
      canRepeatQuestions: this.tableContent.canRepeatQuestions,
      ignoredQuestionCategories: ['EXCERSIZE_QUESTION', 'QUIZ_QUESTION'],
      // onlyTestQuestions: this.tableContent.onlyTestQuestions,
      onlyExerciseQuestions: this.tableContent.onlyExerciseQuestions,
      onlyQuizQuestions: this.tableContent.onlyQuizQuestions,
    };
    this.changeIgnoredQuestionCategories(
      generateQuestionsObj.onlyExerciseQuestions,
      generateQuestionsObj.onlyQuizQuestions,
      generateQuestionsObj
    );
    this.tableContent.subTopicInfo.forEach(
      (subTopic: questionDistributionSubTopicInfo, subTopicIndex: number) => {
        let questionSpecObj: questionSpecification = {
          difficultLevel: 0,
          noOfQuestions: 0,
          questionType: 0,
        };
        let questionSpecifications: questionSpecification[] = [];

        // ** loop for making questionSpecObj based on difficulty level.
        this.difficultyLevels.forEach(
          (difficultyLevel, difficultyLevelIndex) => {
            let mcqControl = this.getControl(
              subTopicIndex,
              true,
              difficultyLevelIndex + 1
            );
            let freetextControl = this.getControl(
              subTopicIndex,
              false,
              difficultyLevelIndex + 1
            );
            if (parseInt(mcqControl.value) > 0) {
              questionSpecObj = {
                difficultLevel: difficultyLevel.level,
                noOfQuestions: parseInt(mcqControl.value),
                questionType: 1,
                // questions: [],
              };
              questionSpecifications.push(questionSpecObj);
            }
            if (parseInt(freetextControl.value) > 0) {
              questionSpecObj = {
                difficultLevel: difficultyLevel.level,
                noOfQuestions: parseInt(freetextControl.value),
                questionType: 2,
                // questions: [],
              };
              questionSpecifications.push(questionSpecObj);
            }
          }
        );
        let subTopicQuestionDetail: subTopicQuestionDetail = {
          subTopicId: subTopic.subTopicId,
          questionSpecifications: questionSpecifications,
        };
        if (questionSpecifications.length > 0) {
          generateQuestionsObj.subTopicQuestionDetails.push(
            subTopicQuestionDetail
          );
        }
      }
    );
    console.log(generateQuestionsObj);
    if (generateQuestionsObj.subTopicQuestionDetails.length > 0) {
      this.generateQuestionStructArr = [];
      this.generateQuestionStructArr.push(generateQuestionsObj);
    }
    console.log(this.generateQuestionStructArr);
  }

  async checkValidityAndCloseDialog(closeDialog: boolean) {
    if (this.isGenerateQuestionsAllowed === false) {
      this.makeGenerateQuestionStruct();
      // if (this.generateQuestionStructArr[0].subTopicQuestionDetails.length > 0)
      try {
        this.areQuestionsGenerating = true;
        const res: generateQuestionStructNew[] =
          await this.globalApiService.getQuestionsGeneratedNewSync(
            this.generateQuestionStructArr
          );

        // this.globalApiService
        //   .getQuestionsGeneratedNew(this.generateQuestionStructArr)
        //   .subscribe({
        //     next: (res) => {
        //       console.log(this.generateQuestionStructArr, res);
        //       // this.generateQuestionStructArr[0].subTopicQuestionDetails.forEach((subTopicQues,subTopicQuesIndex) => {
        //       //   subTopicQues.questionSpecifications.forEach((quesSpec, quesSpecIndex) => {})
        //       // })
        this.areQuestionsGenerating = false;
        if (res.length > 0) {
          console.log(res);
          console.log('yo');
          this.generateQuestionStructArr[0].generatedQuestions =
            res[0].subTopicQuestionDetails;
          this.generateQuestionStructArr[0].subTopicQuestionDetails.forEach(
            (subTopicDetail, subTopicDetailIndex) => {
              subTopicDetail.questionSpecifications.forEach(
                (questionSpec, questionSpecIndex) => {
                  if (!questionSpec.questions) {
                    questionSpec.questions = [];
                  }
                }
              );
              res[0].subTopicQuestionDetails.forEach(
                (subTopicQuestionDetail, subTopicQuestionDetailIndex) => {
                  if (
                    subTopicQuestionDetail.subTopicId ===
                    subTopicDetail.subTopicId
                  ) {
                    subTopicDetail.questionSpecifications.forEach(
                      (questionSpec, questionSpecIndex) => {
                        if (!questionSpec.questions) {
                          questionSpec.questions = [];
                        }
                        if (
                          questionSpec.difficultLevel ===
                            subTopicQuestionDetail.difficultLevel &&
                          questionSpec.questionType ===
                            subTopicQuestionDetail.questionType
                        ) {
                          questionSpec.questions?.push(subTopicQuestionDetail);
                        }
                      }
                    );
                  }
                }
              );
            }
          );
          this.generateQuestionStructArr[0].subTopicQuestionDetails.forEach(
            (subTopicQuestionDetail, subTopicQuestionDetailIndex) => {
              subTopicQuestionDetail.questionSpecifications.forEach(
                (questionSpec, questionSpecIndex) => {
                  console.log(questionSpec);
                  let questionType =
                    questionSpec.questionType === 1 ? 'mcq' : 'freetext';
                  this.difficultyLevels.forEach(
                    (difficultyLevel, difficultyLevelIndex) => {
                      if (
                        difficultyLevel.level === questionSpec.difficultLevel
                      ) {
                        let control = `${questionType}-${difficultyLevel.name}-${subTopicQuestionDetail.subTopicId}`;
                        if (
                          questionSpec.noOfQuestions !==
                          questionSpec.questions?.length
                        ) {
                          if (this.quesFinalPattern.isValidQuestionnaire) {
                            this.quesFinalPattern.isValidQuestionnaire = false;
                          }
                          this.subTopicInfoForm.controls[control].setErrors({
                            perfectGeneration: false,
                            questionsDeleted: false,
                            deletedQuestions: questionSpec.deletedQuestions,
                            presentQuestions: questionSpec.presentQuestions,
                            noOfQuestions: questionSpec.noOfQuestions,
                            generatedQuestions: questionSpec.questions?.length,
                          });
                        } else {
                          this.subTopicInfoForm.controls[
                            control
                          ].updateValueAndValidity();
                        }
                      }
                    }
                  );
                }
              );
            }
          );
        }
      } catch (error) {
        console.error(error);
        this.notifier.notify('error', 'Error fetching the generated questions');
        this.areQuestionsGenerating = false;
      }
      console.log(this.subTopicInfoForm);
      // console.log(this.subTopicInfoForm.errors);
      // if (this.subTopicInfoForm.errors === null) {
      //   this.isGenerateQuestionsAllowed = true;
      // } else {
      //   this.isGenerateQuestionsAllowed = false;
      // }
      console.log(this.subTopicInfoForm.valid);
      //   if (closeDialog) {
      //     if (this.subTopicInfoForm.valid) {
      //       this.isGenerateQuestionsAllowed = true;
      //       console.log('in if');
      //       // if (this.subTopicInfoForm.valid) {
      //       this.quesFinalPattern.isValidQuestionnaire = true;
      //       this.quesFinalPattern.questionStructList =
      //         this.generateQuestionStructArr;
      //       this.dialogRef.close(this.quesFinalPattern);
      //       // }
      //       console.log(this.subTopicInfoForm);
      //     } else if (this.isGenerateQuestionsAllowed === false) {
      //       this.isGenerateQuestionsAllowed = true;
      //     } else if (this.isGenerateQuestionsAllowed) {
      //       this.quesFinalPattern.questionStructList =
      //         this.generateQuestionStructArr;
      //       this.dialogRef.close(this.quesFinalPattern);
      //     }
      //   }
      //   },
      //   error: (err) => {
      //     console.log(err);
      //   },
      // });
    }
    if (closeDialog) {
      if (this.subTopicInfoForm.valid) {
        this.isGenerateQuestionsAllowed = true;
        console.log('in if');
        // if (this.subTopicInfoForm.valid) {
        this.quesFinalPattern.isValidQuestionnaire = true;
        this.quesFinalPattern.questionStructList =
          this.generateQuestionStructArr;
        this.dialogRef.close(this.quesFinalPattern);
        // }
        console.log(this.subTopicInfoForm);
      } else if (this.isGenerateQuestionsAllowed === false) {
        this.isGenerateQuestionsAllowed = true;
      } else if (this.isGenerateQuestionsAllowed) {
        this.quesFinalPattern.questionStructList =
          this.generateQuestionStructArr;
        this.dialogRef.close(this.quesFinalPattern);
      }
    }
    // this.dialogRef.close(this.generateQuestionStructArr);
  }

  getTooltip(index: number, isMcq: boolean, status: number): string {
    let control = this.getControl(index, isMcq, status);
    console.log(control.errors);
    let errors = control.errors;
    let returnString = errors?.['questionsDeleted']
      ? `Deleted ${errors?.['deletedQuestions']}`
      : `Generated ${errors?.['generatedQuestions']}`;
    return returnString + ` of ${errors?.['noOfQuestions']} questions`;
  }

  createQuestionAPI() {
    let data = [
      {
        moduleName: 'Module Math 1',
        subTopicQuestionDetails: [
          {
            questionSpecifications: [
              {
                difficultyLevel: 1,
                noOfQuestions: 30,
                questionType: 1,
              },
            ],
            subTopicId: 5,
          },
        ],
      },
    ];
    this.globalApiService.getQuestionsGenerated(data).subscribe({
      next: (res) => {
        console.log(res);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  printEl() {
    console.log(this.tableContent.canRepeatQuestions);
  }
}
